<template>
  <Modal
    class="detail-modal"
    :data-testid="testId"
    :is-open="isOpen"
    size="md"
    :title="title"
    v-on="$listeners"
  >
    <component :is="getComponent" :modal-info="detailProps" />
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { EarningDetail } from '@/modules/wealth/components/EarningDetail';
import { RedeemDetail } from '@/modules/wealth/components/RedeemDetail';
import { StrategyDetail } from '@/modules/wealth/components/StrategyDetail';
import { MinimumDepositDetail } from '@/modules/wealth/components/MinimumDepositDetail';
import { TransactionDetail } from '@/modules/wealth/components/TransactionDetail';
import { MandateDetail } from '@/modules/wealth/components/MandateDetail';
import { CostDetail } from '@/modules/wealth/components/CostDetail';
import { Modal } from '@warrenbrasil/nebraska-web';
import { DetailType } from '@/modules/wealth/types';
import MinimumRedemptionDetail from '@/modules/wealth/components/MinimumRedemptionDetail/MinimumRedemptionDetail.vue';

const components = new Map<string, Vue.Component>([
  [DetailType.Transaction, TransactionDetail],
  [DetailType.Earning, EarningDetail],
  [DetailType.Redeem, RedeemDetail],
  [DetailType.MinimumDeposit, MinimumDepositDetail],
  [DetailType.MinimumRedemption, MinimumRedemptionDetail],
  [DetailType.Strategy, StrategyDetail],
  [DetailType.Mandate, MandateDetail],
  [DetailType.Cost, CostDetail]
]);

interface Props {
  isOpen: boolean;
  title: string;
  detailType: string;
  detailProps: Object;
}

const props = withDefaults(defineProps<Props>(), { isOpen: false });

const getComponent = computed(() => components.get(props.detailType));
const testId = computed(() => `${props.detailType}-modal`);
</script>

<style lang="less" scoped>
:deep(.modal-content) {
  padding: 0;
}
.content_modal-enter,
.content_modal-leave-to {
  transform: translate(100%, 0);
}
</style>
